import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m0-1.435c4.723 0 8.565-3.842 8.565-8.565S16.723 3.435 12 3.435 3.435 7.278 3.435 12c0 4.723 3.843 8.565 8.565 8.565m3.067-4.477-3.07-3.08-3.082 3.049a.714.714 0 1 1-1.004-1.016l3.077-3.044L7.921 8.92A.714.714 0 1 1 8.933 7.91l3.071 3.081 3.081-3.049A.714.714 0 1 1 16.09 8.96l-3.078 3.044 3.066 3.077a.714.714 0 1 1-1.011 1.008"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }